import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./style/CreateCourseSuccessPage.module.css";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createCourseActions,
  editingCourseActions,
} from "../../redux/modules/course/slices";

const CreateCourseSuccessPage = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const courseId = location.state?.courseId;

  // useEffect(() => {
  //   return () => {
  //     dispatch(editingCourseActions.resetEditingCourse());
  //   };
  // }, []);

  if (!courseId) {
    return (
      <div className="position-relative w-100 h-50 text-center py-5">
        <div className="success my-5">
          <div className="h5 my-3">You haven't created course yet.</div>
          <p>
            You can create a new course{" "}
            <Link to={"/create-new-course"}>here</Link>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="position-relative w-100 h-50 text-center py-5">
      <div className="success my-5">
        <i className="bi bi-check-circle-fill text-success fs-1"></i>
        <div className="h5 my-3">Create course successfully</div>

        <p>
          You can see detail course <Link to={`/course/${courseId}`}>here</Link>{" "}
          or create a new course <Link to={"/create-new-course"}>here</Link>.
        </p>
      </div>
    </div>
  );
};

/* required: display name */
CreateCourseSuccessPage.displayName = "CreateCourseSuccessPage";

/* required: props types */
CreateCourseSuccessPage.propTypes = {};

/* required: default props */
CreateCourseSuccessPage.defaultProps = {};

export { CreateCourseSuccessPage };
